import { FriendlyDateFormatPipe } from '../pipes/friendly-date-format.pipe';
import { LinkifyPipe } from '../pipes/linkify.pipe';
import { MediaListComponent } from '../components/media-list/media-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { MemberLineItemComponent } from '../components/member-line-item/member-line-item.component';
import { AddMemberFormComponent } from '../components/add-member-form/add-member-form.component';
import { AvatarInitialsComponent } from '../components/avatar-initials/avatar-initials.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GsdIntlTelInputComponent } from '../components/gsd-intl-tel-input/gsd-intl-tel-input.component';
import { AddMessageFormComponent } from '../components/add-message-form/add-message-form.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forChild(),
  ],
  declarations: [
    AddMessageFormComponent,
    MediaListComponent,
    AvatarInitialsComponent,
    AddMemberFormComponent,
    MemberLineItemComponent,
    GsdIntlTelInputComponent,
    FriendlyDateFormatPipe,
    LinkifyPipe,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    AddMessageFormComponent,
    MediaListComponent,
    AddMemberFormComponent,
    MemberLineItemComponent,
    AvatarInitialsComponent,
    GsdIntlTelInputComponent,
    HttpClientModule,
    FriendlyDateFormatPipe,
    LinkifyPipe,
  ],
})
export class SharedModule {}
